import { useState } from 'react'

import { TwoFaProvider } from '@/context/TwoFaContext'
import { WrapperProps } from '@/shared/routes'
import Panel2Fa from '@/pages/user/MyProfile/tabPanel/2FAPanel'
import AccountManagementPanel from '@/pages/user/MyProfile/tabPanel/AccountManagementPanel'
import Layout from '@/components/Layout'
import TabNavigation, { TTabItems } from '@/components/TabNavigation'

import MyProfilePanel from './tabPanel/MyProfilePanel'

/**
 * My Profile Tab Config
 */
const MyProfileTabConfig: TTabItems[] = [
  {
    eventKey: 'my-profile',
    header: {
      navItemStyle: 'nav',
      title: 'My Profile',
    },
    body: {
      children: <MyProfilePanel />,
      bodyCn: 'p-8',
    },
  },
  {
    eventKey: 'account-mgmt',
    header: {
      navItemStyle: 'nav',
      title: 'Account Management',
    },
    body: {
      children: <AccountManagementPanel />,
      bodyCn: 'p-8',
    },
  },
  {
    eventKey: '2fa',
    header: {
      navItemStyle: 'nav',
      title: '2FA',
    },
    body: {
      bodyCn: 'p-8',
      children: (
        <TwoFaProvider>
          <Panel2Fa />
        </TwoFaProvider>
      ),
    },
  },
]

export default function MyProfile(props: WrapperProps) {
  const [activeKey, setActiveKey] = useState<string>(MyProfileTabConfig[0].eventKey)
  return (
    <Layout title={props.title} noPadding>
      <TabNavigation
        activeKey={activeKey}
        headerNavCn='flex gap-8 px-8 border-b bdr mk-horz-menu'
        tabItems={MyProfileTabConfig}
        onNavigate={(eventKey: string) => setActiveKey(eventKey)}
      />
    </Layout>
  )
}
